export const ESTADO_CONFIGURACION_ANTIFRAUDE = {
  EXENTO: 1,
  VERIFACTU: 2,
} as const
export type EstadoConfiguracionAntifraudeType =
  (typeof ESTADO_CONFIGURACION_ANTIFRAUDE)[keyof typeof ESTADO_CONFIGURACION_ANTIFRAUDE]
